module.exports = __webpack_public_path__ + "img/airbnb-1.b5a8b3a4.jpg";